import { Player } from './player';
import { WithStatsForNerdsDataGatherer } from '../stats-for-nerds/player-modules/data-gatherer';
class WebPlayerBase extends Player {
    options;
    adapter;
    constructor(options, adapter) {
        super(options, adapter);
        this.adapter = adapter;
        this.options = options;
    }
    setView(view) {
        this.adapter.setView(view);
    }
}
// @ts-expect-error WebPlayerBase is instance of BasePlayer, but doesn't have the type
export const WebPlayer = WithStatsForNerdsDataGatherer(WebPlayerBase);
